import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaBars, FaDownload, FaTimes } from 'react-icons/fa';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navClass = ({ isActive }) =>
    `nav-link ${isActive ? 'nav-link-active' : ''}`;

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="sticky top-0 z-40 border-b border-emerald-200/10 bg-emerald-950/70 backdrop-blur-xl">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link to="/" className="group flex items-center" onClick={closeMenu}>
          <span className="text-lg font-bold tracking-tight text-emerald-50 transition-colors duration-200 group-hover:text-emerald-200 sm:text-xl">
              Srinesh Selvaraj
          </span>
        </Link>

        <div className="hidden items-center gap-2 md:flex">
          <NavLink to="/experience" className={navClass}>
              Experience
          </NavLink>
          <NavLink to="/projects" className={navClass}>
              Projects
          </NavLink>
          <a
            href="/resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-emerald-300/25 bg-emerald-500/15 px-4 py-2 text-sm font-semibold text-emerald-50 transition-all duration-200 hover:-translate-y-0.5 hover:bg-emerald-500/25"
          >
            <FaDownload className="h-3.5 w-3.5" />
            Resume
          </a>
        </div>

        <button
          type="button"
          className="icon-button md:hidden"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      <div
        className={`overflow-hidden border-t border-emerald-200/10 transition-all duration-300 md:hidden ${
          menuOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-4 py-3 sm:px-6">
          <NavLink to="/experience" className={navClass} onClick={closeMenu}>
            Experience
          </NavLink>
          <NavLink to="/projects" className={navClass} onClick={closeMenu}>
            Projects
          </NavLink>
          <a
            href="/resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
            className="nav-link inline-flex items-center gap-2"
          >
            <FaDownload className="h-3.5 w-3.5" />
            Resume
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 